import { render, staticRenderFns } from "./AttendanceItemPage.vue?vue&type=template&id=0fba6ad0&"
import script from "./AttendanceItemPage.vue?vue&type=script&lang=js&"
export * from "./AttendanceItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports